<admin-header [primaryButtons]="headerPrimaryButtons" [secondaryButtons]="headerSecondaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<dx-data-grid class="data-grid" [dataSource]="items" [remoteOperations]="false" [allowColumnReordering]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true" [showBorders]="true" (onExporting)="logExport()">
    <dxo-paging [pageSize]="100"></dxo-paging>
	<dxo-state-storing [enabled]="true" type="localStorage" storageKey="ordersRfq"></dxo-state-storing>
    <dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
    <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"></dxo-search-panel>
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-grouping [autoExpandAll]="false"></dxo-grouping>
	<dxo-export [enabled]="canExportGrid"></dxo-export>
	<dxi-column type="buttons">
        <dxi-button hint="View" icon="fal fa-eye" [onClick]="viewRow"></dxi-button>
		<dxi-button *ngIf="editEnabled" hint="Edit" icon="fal fa-pencil" [onClick]="editRow" [visible]="isEditButtonVisible"></dxi-button>
		<dxi-button *ngIf="deleteEnabled" icon="fal fa-trash" [onClick]="deleteRow"></dxi-button>
    </dxi-column>
    <dxi-column dataField="id" alignment="left" sortOrder="asc"></dxi-column>
	<dxi-column dataField="supplier.name" caption="Supplier"></dxi-column>
	<dxi-column dataField="dateSent" dataType="date" format="dd/MM/yyyy"></dxi-column>
	<dxi-column dataField="purchaseType" caption="Type">
		<dxo-lookup [dataSource]="purchaseTypes" displayExpr="name" valueExpr="id"></dxo-lookup>
	</dxi-column>
	<dxi-column dataField="status" caption="Status">
		<dxo-lookup [dataSource]="statuses" displayExpr="name" valueExpr="id"></dxo-lookup>
	</dxi-column>
</dx-data-grid>